import React from 'react'

export default function PageTitle(props) {
  return (
    <div className="col-12">
      <h1>{props.children}</h1>
    </div>
  )
}
